import {Container} from "./styled";
import {CSSProperties} from "react";
import {useTheme} from "styled-components";

interface LineProps extends CSSProperties {}

export const Line: React.FC<LineProps> = (props) => {
  const {isDark, white01, black01} = useTheme();
  const {
    height = "1px",
    width = "100%",
    margin = ".8rem 0",
    backgroundColor = isDark ? white01 : black01,
  } = props;
  return (
    <Container
      style={{
        width,
        margin,
        height,
        backgroundColor,
        ...props,
      }}
    />
  );
};
